class PanierPremiumService {
    urlAPP = window.location.origin

    constructor() {}

    async LoadPanier(referencePaiement) {
        const requestOptions = {
            method: 'GET'
        }

        var param = referencePaiement ? '?rp=' + referencePaiement : ''

        return await this.#Fetch('Panier', param, requestOptions)
    }

    async AddProduit(refModele, codeCouleur, codeTaille, origineMiseAuPanier) {
        const requestOptions = {
            method: 'PUT'
        }

        const params =
            '?' +
            $.param({
                refModele: refModele,
                codeCouleur: codeCouleur,
                codeTaille: codeTaille,
                origineMiseAuPanier
            })

        return await this.#Fetch('Article', params, requestOptions)
    }

    async DeleteLignePanier(panierLigneId) {
        const requestOptions = {
            method: 'DELETE'
        }

        const params =
            '?' +
            $.param({
                panierLigneId: panierLigneId
            })

        return await this.#Fetch('Article', params, requestOptions)
    }

    async UpdateTransport(referencePanierVendeur, referenceTransport) {
        const requestOptions = {
            method: 'POST'
        }

        const params =
            '?' +
            $.param({
                refPanierVendeur: referencePanierVendeur,
                refModeExpedition: referenceTransport
            })

        return await this.#Fetch('Modelivraison', params, requestOptions)
    }

    async UpdatePaiement(referencePaiement, referenceModePaiement) {
        const requestOptions = {
            method: 'POST'
        }

        var params =
            '?' +
            $.param({
                refModePaiement: referenceModePaiement
            })

        params += referencePaiement ? '&rp=' + referencePaiement : ''

        return await this.#Fetch('ModePaiement', params, requestOptions)
    }

    async UpdateAvoirs(referencePaiement, isDelete) {
        const requestOptions = {
            method: isDelete ? 'DELETE' : 'PUT'
        }

        var params = referencePaiement ? '?rp=' + referencePaiement : ''

        return await this.#Fetch('Avoirs', params, requestOptions)
    }

    async UpdateBonsAchat(referencePaiement, isDelete) {
        const requestOptions = {
            method: isDelete ? 'DELETE' : 'PUT'
        }

        var params = referencePaiement ? '?rp=' + referencePaiement : ''

        return await this.#Fetch('BonsAchat', params, requestOptions)
    }

    async UpdateCodePromo(isDelete, codePromo) {
        const requestOptions = {
            method: isDelete ? 'DELETE' : 'PUT'
        }

        const params =
            '?' +
            $.param({
                codePromo: codePromo
            })

        return await this.#Fetch(
            'Codepromo',
            isDelete ? '' : params,
            requestOptions
        )
    }

    async UpdateOption(referencePanierVendeur, referenceOption, isDelete) {
        const requestOptions = {
            method: isDelete ? 'DELETE' : 'PUT'
        }

        const params =
            '?' +
            $.param({
                referencePanierVendeur: referencePanierVendeur,
                referenceOption: referenceOption
            })

        return await this.#Fetch('Option', params, requestOptions)
    }

    async ListPointRelais(recherchePR, referenceVendeur) {
        const requestOptions = {
            method: 'GET'
        }

        const params = this.#createRequestParams(recherchePR)

        return await this.#Fetch(
            'PointRelais',
            '?' + params + '&refVendeur=' + referenceVendeur,
            requestOptions
        )
    }

    async UpdatePointRelais(refModeExpedition, refPanierVendeur, refRelais) {
        const requestOptions = {
            method: 'POST'
        }

        const params =
            '?' +
            $.param({
                refModeExpedition: refModeExpedition,
                refPanierVendeur: refPanierVendeur,
                refRelais: refRelais
            })

        return await this.#Fetch('PointRelais', params, requestOptions)
    }

    async UpdateAdresseLivraison(client) {
        const requestOptions = {
            method: 'POST',
            body: JSON.stringify({ client: client }),
            headers: {
                'content-type': 'application/json'
            }
        }

        //var _client = JSON.parse(JSON.stringify(client));

        return await this.#Fetch('AdresseLivraison', '', requestOptions)
    }

    async #Fetch(methodName, params, requestOptions) {
        var response = await fetch(
            this.urlAPP + '/PanierApi/' + methodName + '/' + params,
            requestOptions
        )

        if (response.ok) {
            var returnValue = await response.json()
            return returnValue
        } else {
            throw new Error('une erreur serveur est apparue')
        }
    }

    #createRequestParams = (inputObj) =>
        Object.entries(inputObj)
            .map((i) =>
                ['recherche.' + i[0], encodeURIComponent(i[1])].join('=')
            )
            .join('&')
            .toString()
}

export default new PanierPremiumService()
